import React from 'react'
import './ContactUsHeroSection.component.scss'

const ContactUsHeroSection = () => {
  return (
    <section className='contact-us-hero-section'>
      <div className='contact-us-hero-section__inner'>
        <h1 className='contact-us-hero-section__heading'>Let's Find the Right Coverage for You</h1>
        <p className='contact-us-hero-section__subheading'>
          Whether you're exploring health insurance options, life coverage, or supplemental benefits — our licensed
          agents are here to help you navigate your choices with confidence.
        </p>
      </div>
    </section>
  )
}

export default ContactUsHeroSection
